import { useLocation, useNavigate } from 'react-router-dom';
import ParkingCheckoutLayout from '../../components/checkout/ParkingCheckoutLayout';

export default function ParkingCheckout() {
    const location = useLocation();
    const navigate = useNavigate();
    const paymentSession = location.state?.paymentSession;
    const bookingData = location.state?.bookingData;

    if (!paymentSession && !bookingData) {
        return (
            <div className="text-center py-8">
                <p className="text-red-600 mb-4">No booking data found. Please go back and try again.</p>
                <button onClick={() => navigate('/shoppingcart')} className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg">Back to Cart</button>
            </div>
        );
    }

    const items = bookingData?.items || [];
    const total = bookingData?.total || 0;
    const currency = bookingData?.currency;

    const sidebar = (
        <>
            {items.map(item => (
                <div key={item.id} className="mb-3">
                    <h3 className="font-bold text-gray-900">{item.name}</h3>
                    <p className="text-sm text-gray-600">{item.description}</p>
                    <p className="text-sm text-gray-500">Qty: {item.quantity}</p>
                </div>
            ))}
            <button onClick={() => navigate('/shoppingcart')} className="text-purple-700 text-sm font-medium hover:underline mb-4 block">
                &#8592; Change booking details
            </button>
        </>
    );

    return (
        <ParkingCheckoutLayout
            paymentSession={paymentSession}
            sidebarContent={sidebar}
            total={total}
            currency={currency}
            containerId="parking-hosted-checkout"
            headingText="Booking"
            marketingText="Yes, I would like to receive Airport discounts, travel blogs and deals, news, announcements, and competitions. By ticking this box, I agree to be contacted by email and SMS."
        />
    );
}
